import { call, put } from "redux-saga/effects";
import { instructorCourseApi } from "@services/api";
import { getUpcomingCoursesActions } from "../slices";

function* getUpcomingCoursesWorker({ payload }) {
  try {
    yield put(getUpcomingCoursesActions.pending());
    const response = yield call(instructorCourseApi.getUpcomingCourses, payload);
    yield put(getUpcomingCoursesActions.success(response));
    // TODO: handle callback | onSuccess
  } catch (error) {
    yield put(getUpcomingCoursesActions.failure(error));
    // TODO: handle callback | onFailure
  }
}

export { getUpcomingCoursesWorker };
